import { render } from "./MMMainMembers.vue?vue&type=template&id=47407e3c"
import script from "./MMMainMembers.vue?vue&type=script&lang=js"
export * from "./MMMainMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__